/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint jsx-a11y/anchor-is-valid: "off"*/
import React, { useEffect } from "react";
import MapBase from "./MapBase";
import { MapPropsProvider } from "./MapPropsContext";
import useMapProps from "./useMapProps";
import WidgetContainer from "./widgets/WidgetContainer";
import WidgetJobCategoryCode from "./widgets/WidgetJobCategoryCode";
import { getApiUrl, makeTableSorterFn } from "../../utils";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
import WidgetTable from "./widgets/WidgetTable";
import { WELL_KNOWN_POSITION } from "../../Constants";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import AlignCenterText from "./widgets/AlignCenterText";
import AlignRightText from "./widgets/AlignRightText";
import WidgetLegend from "./widgets/WidgetLegend";

export default function MapJob() {
  // const [error, setError] = useState();
  // const [initGetAddress, setInitGetAddress] = useState(true);
  // if(initGetAddress){
  //   setInitGetAddress(false);
  //   getUserAddress().then(({ data }) => {
  //     console.log("getUserAddress data:", data);
  //     const latitude = data['lat'];
  //     const longitude = data['lon'];
  //     const zoom = 13;
  //     setMapCenter({ latitude, longitude, zoom });
  //   }).catch(e => {
  //     setError(e);
  //   })
  // }

  // 아이콘 크기 수식 삭제
  const mapProps = useMapProps({
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.서울특별시,
      zoom: 12,
    },
    INITIAL_POINT_LAYER_PROPS: {
      getIconCode: () => "일자리",
    },
    INITIAL_WIDGET_STATE: {
      jobs_cd_list: OPTIONS.map(({ jobs_cd }) => jobs_cd),
    },
  });

  const {
    currentDistrictCode,
    setCurrentDistrictCode,
    clickedPointIconObjects,
    widgetState,
    setPointsLayerFilterFunc,
    setIsClusteringPoint,
    districtLv1,
    setCurrentDistrictName,
  } = mapProps;

  useEffect(() => {
    setIsClusteringPoint(true);
    setCurrentDistrictCode(11);
  }, []);

  useEffect(() => {
    if (!currentDistrictCode) {
      setPointsLayerFilterFunc(() => () => false);
    } else {
      const { jobs_cd_list } = widgetState;
      const flatted_jobs_cd_list = jobs_cd_list.flat();

      // 마감일자 데이터는 두 가지 유형입니다. close_dt: "채용시까지  20-03-12" 또는 close_dt: "20-02-07"
      let today = Date.now();

      setPointsLayerFilterFunc(() => ({ jobs_cd, district_code, close_dt }) => {
        let deadline; // 마감일의 1970년 1월 1일 0시 0분 0초부터 현재까지 경과된 밀리 초를 저장할 변수
        let invalid; // 마감일이 지났으면 true, 안 지났으면 false
        // 마감일이 지난 채용 정보는 걸러냅니다.
        if (close_dt.includes("채용시까지")) {
          deadline = "20" + close_dt.slice(7);
          deadline = Date.parse(deadline);
          invalid = deadline - today < 0;
        } else {
          deadline = Date.parse("20" + close_dt);
          invalid = deadline - today < 0;
        }
        // 마감일(close_dt)이 안 지난 것(!invalid)만 return 합니다.
        return (
          district_code &&
          district_code.startsWith(currentDistrictCode) && // TODO: district_code 필드를 추가하기
          !invalid &&
          flatted_jobs_cd_list.includes(jobs_cd)
        );
      });
    }
  }, [widgetState, currentDistrictCode]);

  useEffect(() => {
    if (districtLv1) {
      setCurrentDistrictName(districtLv1);
    }
  }, [districtLv1]);

  const worknet_url = (wanted_info_url) => {
    return wanted_info_url["wanted_info_url"];
  };

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase>
        <WidgetContainer>
          <div>
            {/*<WidgetGeocoding zoom={12} />*/}
            <WidgetDistrictSelect injectDistrictLv1Value={"11"} />
            <WidgetJobCategoryCode />
          </div>
        </WidgetContainer>

        <WidgetTableClicked
          fetchUrl={getApiUrl({ type: "type2" })}
          getTitle={(objects) => `${objects.length}개의 구인정보`}
          objects={clickedPointIconObjects}
          getRowTitle={({ company }) => company}
          getRow={({
            uid,
            company,
            title,
            region,
            basic_addr,
            sal,
            career,
            wanted_info_url,
            reg_dt,
            close_dt,
          }) => (
            <table>
              <tbody>
                {/*<tr>*/}
                {/*  <th>허가번호</th>*/}
                {/*  <td>{formatUid(uid)}</td>*/}
                {/*</tr>*/}
                <tr>
                  <th>회사명</th>
                  {/*<td><a href={wanted_info_url} target="_blank">{company}</a></td>*/}
                  <td>
                    <a
                      href={""}
                      onClick={() =>
                        window.open(worknet_url({ wanted_info_url }), "_blank")
                      }
                    >
                      {company}
                    </a>
                  </td>
                  {/*<td><Link to={wanted_info_url}>{company}</Link></td>*/}
                </tr>
                <tr>
                  <th>직종</th>
                  <td>{title}</td>
                </tr>
                {/*<tr>*/}
                {/*  <th>지역</th>*/}
                {/*  <td>{region}</td>*/}
                {/*</tr>*/}
                <tr>
                  <th>근무지</th>
                  <td>{basic_addr}</td>
                </tr>
                <tr>
                  <th>급여</th>
                  <td>{sal}</td>
                </tr>
                <tr>
                  <th>경력 여부</th>
                  <td>{career}</td>
                </tr>
                <tr>
                  <th>등록일자</th>
                  <td>{reg_dt}</td>
                </tr>
                <tr>
                  <th>마감일자</th>
                  <td>{close_dt}</td>
                </tr>
              </tbody>
            </table>
          )}
        />
        <WidgetTable
          fetchUrl={getApiUrl({ type: "type1" })}
          getTitle={(layer) => `${layer.length}개의 일자리`}
          columns={[
            {
              title: "순번",
              dataIndex: "index",
              key: "index",
              width: 75,
              // fixed: "left",
              align: "center",
              // sorter: makeTableSorterFn("index"),
            },
            // {title: '구인번호', dataIndex: 'uid', key: 'uid'},
            {
              title: "회사명",
              dataIndex: "company",
              key: "company",
              width: 180,
              // fixed: "left",
              // sorter: makeTableSorterFn("company"),
            },
            {
              title: "채용 제목",
              dataIndex: "title",
              key: "title",
              width: 240,
              // sorter: makeTableSorterFn("title")
            },
            {
              title: "임금 형태",
              dataIndex: "sal_tp_nm",
              key: "sal_tp_nm",
              width: 120,
              render: (text) => AlignCenterText({ text }),
              // sorter: makeTableSorterFn("sal_tp_nm"),
            },
            {
              title: "급여",
              dataIndex: "sal",
              key: "sal",
              width: 160,
              render: (text) => AlignRightText({ text }),
              // sorter: makeTableSorterFn("sal"),
            },
            {
              title: "최소임금액",
              dataIndex: "min_sal",
              key: "min_sal",
              width: 140,
              render: (text) => AlignRightText({ text, numberComma: true }),
              // sorter: makeTableSorterFn("min_sal"),
            },
            {
              title: "최대임금액",
              dataIndex: "max_sal",
              key: "max_sal",
              width: 140,
              render: (text) => AlignRightText({ text, numberComma: true }),
              // sorter: makeTableSorterFn("max_sal"),
            },
            {
              title: "근무지역",
              dataIndex: "region",
              key: "region",
              width: 140,
              // sorter: makeTableSorterFn("region"),
            },
            {
              title: "근무형태",
              dataIndex: "holiday_tp_nm",
              key: "holiday_tp_nm",
              width: 140,
              // sorter: makeTableSorterFn("holiday_tp_nm"),
            },
            {
              title: "최소 학력",
              dataIndex: "min_edubg",
              key: "min_edubg",
              width: 140,
              // sorter: makeTableSorterFn("min_edubg"),
            },
            {
              title: "최대 학력",
              dataIndex: "max_edubg",
              key: "max_edubg",
              width: 140,
              // sorter: makeTableSorterFn("max_edubg"),
            },
            {
              title: "경력",
              dataIndex: "career",
              key: "career",
              width: 140,
              // sorter: makeTableSorterFn("career"),
            },
            {
              title: "등록일자",
              dataIndex: "reg_dt",
              key: "reg_dt",
              width: 140,
              render: (text) => AlignCenterText({ text }),
              // sorter: makeTableSorterFn("reg_dt"),
            },
            {
              title: "마감일자",
              dataIndex: "close_dt",
              key: "close_dt",
              width: 180,
              // sorter: makeTableSorterFn("close_dt"),
            },
            // {title: '정보제공처', dataIndex: 'info_svc', key: 'info_svc', sorter: makeTableSorterFn('info_svc')},
            {
              title: "근무지 우편주소",
              dataIndex: "zip_cd",
              key: "zip_cd",
              width: 140,
              render: (text) => AlignCenterText({ text }),
              // sorter: makeTableSorterFn("zip_cd"),
            },
            {
              title: "근무지",
              dataIndex: "basic_addr",
              key: "basic_addr",
              width: 240,
              // sorter: makeTableSorterFn("basic_addr"),
            },
            {
              title: "상세주소",
              dataIndex: "detail_addr",
              key: "detail_addr",
              width: 240,
              // sorter: makeTableSorterFn("detail_addr"),
            },
            {
              title: "고용형태",
              dataIndex: "emp_tp_cd",
              key: "emp_tp_cd",
              width: 240,
              // sorter: makeTableSorterFn("emp_tp_cd"),
            },
            {
              title: "우대조건",
              dataIndex: "pref_cd",
              key: "pref_cd",
              width: 140,
              // sorter: makeTableSorterFn("pref_cd"),
            },
            {
              title: "최종수정일",
              dataIndex: "smodify_dtm",
              key: "smodify_dtm",
              width: 140,
              render: (text) => {
                // text에 시/분까지 포함.
                return `${text.slice(0, 4)}년 ${text.slice(
                  4,
                  6
                )}월 ${text.slice(6, 8)}일`;
              },
              // sorter: makeTableSorterFn("smodify_dtm"),
            },
          ]}
          horizontalScroll={3400}
        />

        <WidgetLegend />
      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
}

export var OPTIONS = [
  { jobs_cd: "13700", label: "정보통신 관리자(부서장)", iconCode: "marker-50" },
  {
    jobs_cd: ["131100", "131200", "131201", "131202", "131203", "132000"],
    label: "컴퓨터하드웨어·통신공학",
    iconCode: "marker-50",
  }, // 022
  {
    jobs_cd: ["1320001", "1320002", "1320003"],
    label: "컴퓨터시스템",
    iconCode: "marker-50",
  }, // 023
  {
    jobs_cd: [
      "133100",
      "133101",
      "133102",
      "133200",
      "133201",
      "133202",
      "133203",
      "133204",
      "133205",
      "133206",
      "133207",
      "133300",
      "133301",
      "133302",
      "133900",
    ],
    label: "소프트웨어",
    iconCode: "marker-50",
  }, // 024
  {
    jobs_cd: [
      "134100",
      "134101",
      "134102",
      "134103",
      "134200",
      "134301",
      "134302",
      "134303",
      "134400",
      "134900",
    ],
    label: "데이터·네트워크 및 시스템 운영",
    iconCode: "marker-50",
  }, //025
  {
    jobs_cd: ["135000", "135001", "135002", "136000"],
    label: "정보 보안 및 통신·방송 송출",
    iconCode: "marker-50",
  }, //026
  {
    jobs_cd: [
      "153100",
      "153101",
      "153102",
      "153103",
      "153104",
      "153105",
      "153106",
      "153107",
      "153200",
      "153201",
      "153202",
      "153203",
      "153204",
      "153205",
      "153206",
      "153300",
    ],
    label: "전기·전자 연구 및 공학기술",
    iconCode: "marker-50",
  }, //029
  {
    jobs_cd: [
      "028202",
      "028203",
      "028204",
      "621100",
      "621200",
      "621300",
      "621400",
      "621900",
      "885901",
    ],
    label: "항공기·선박·철도 조종 및 관제",
    iconCode: "marker-50",
  }, //078
  {
    jobs_cd: ["831100", "831200", "831201", "831202", "831204", "831300"],
    label: "전기공(전기공사)",
    iconCode: "marker-50",
  }, //101
  {
    jobs_cd: [
      "832100",
      "832200",
      "832201",
      "832202",
      "832203",
      "832204",
      "832205",
      "832900",
      "832901",
      "832902",
      "832903",
      "832904",
      "832905",
      "832906",
    ],
    label: "전기·전자 기기 설치·수리(사무용,가전제품,기타)",
    iconCode: "marker-50",
  }, //102
  {
    jobs_cd: [
      "814001",
      "814002",
      "833000",
      "834000",
      "834001",
      "834002",
      "834003",
      "834004",
    ],
    label: "발전·배전 장비, 전기·전자 설비 조작(전기관리)",
    iconCode: "marker-50",
  }, // 103
  {
    jobs_cd: ["835100", "835200"],
    label: "전기·전자 부품·제품 생산기계 조작",
    iconCode: "marker-50",
  }, // 104
  {
    jobs_cd: [
      "817200",
      "836000",
      "836001",
      "836002",
      "836003",
      "836004",
      "836005",
      "836006",
    ],
    label: "전기·전자 부품·제품 조립",
    iconCode: "marker-50",
  }, //105
  {
    jobs_cd: ["841100", "841200", "841900"],
    label: "정보통신기기 설치·수리(컴퓨터,핸드폰)",
    iconCode: "marker-50",
  }, //106
  {
    jobs_cd: ["842100", "842200", "842300", "842301", "842302"],
    label: "방송·통신장비 및 케이블 설치·수리",
    iconCode: "marker-50",
  }, //107
];
